import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

type DateObject = {
  website: string;
  success_rate: number;
  failed_checks: number;
  successful_checks: number;
  total_checks: number;
};

export interface IState {
  items: DateObject[];
  loading: boolean;
}

export const dsHealthCheck = {
  getHealth: createAsyncThunk('dsHealthCheck/getHealth', async (payload: any) => {
    const response = await ApiService.get(`/p_digital_shelf/health_check?${new URLSearchParams(payload).toString()}`);
    return response.data;
  }),
};
export const dsHealthCheckListSlice = createSlice({
  name: 'dsHealthCheckList',
  initialState: {
    items: [],
    loading: true,
  } as IState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(dsHealthCheck.getHealth.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.items = payload;
      })
      .addCase(dsHealthCheck.getHealth.pending, state => {
        state.loading = true;
      });
  },
});

export const dsHealthCheckListActions = dsHealthCheckListSlice.actions;

export type DSHealthSlice = {
  [dsHealthCheckListSlice.name]: ReturnType<(typeof dsHealthCheckListSlice)['reducer']>;
};
